<template>
  <v-app>
    <v-container fluid fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card>
            <v-list-item>
              <v-list-item-content class="headline">
                <v-list-item-avatar>
                  <v-img contain :src="logo" alt="LOGO BRP"></v-img>
                </v-list-item-avatar>
                <p class="subtitle-1 mb-0">Primeiro acesso</p>
              </v-list-item-content>
            </v-list-item>

            <v-card-text>
              <p class="subtitle-2 mb-4">
                Para continuar, defina sua nova senha de acesso ao painel.
              </p>

              <v-form ref="form" v-model="valid" @submit.prevent="handleChangePassword">
                <v-text-field
                  v-model="password"
                  label="Nova senha"
                  outlined
                  append-icon="mdi-eye"
                  :rules="[requiredRule, minPasswordRule]"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                />

                <v-text-field
                  v-model="confirmPassword"
                  label="Confirmar nova senha"
                  outlined
                  append-icon="mdi-eye"
                  :rules="[requiredRule, confirmPasswordRule]"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  @click:append="showConfirmPassword = !showConfirmPassword"
                />

                <v-btn
                  type="submit"
                  :disabled="!valid || saving"
                  :loading="saving"
                  color="#ee2c4f"
                  dark
                  class="mt-5"
                  block
                >
                  Salvar nova senha
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ChangePassword } from "@/services/user/ChangePassword";

export default defineComponent({
  name: "FirstAccessPassword",
  data() {
    return {
      valid: false,
      saving: false,
      showPassword: false,
      showConfirmPassword: false,
      password: "",
      confirmPassword: "",
      logo: require("../../assets/logo-login.png"),
    };
  },
  methods: {
    requiredRule(value: string) {
      return !!value || "O campo é obrigatório";
    },
    minPasswordRule(value: string) {
      return (value && value.length >= 6) || "A senha deve ter pelo menos 6 caracteres";
    },
    confirmPasswordRule(value: string) {
      return value === this.password || "As senhas não conferem";
    },
    async handleChangePassword() {
      if (!this.valid) return;

      this.saving = true;
      try {
        const changePassword = new ChangePassword();
        await changePassword.execute(this.password);
        await this.$store.dispatch("clearSession");
        await this.$store.dispatch("loadSession");
        this.$store.dispatch("showSnack", {
          message: "Senha alterada com sucesso.",
          color: "green",
          timer: 4000,
        });
        this.$router.replace({ name: "home" });
      } catch {
        this.$store.dispatch("showSnack", {
          message: "Não foi possível alterar a senha.",
          color: "red",
          timer: 4000,
        });
      } finally {
        this.saving = false;
      }
    },
  },
});
</script>

<style scoped>
.v-application {
  background: #e5183d;
  height: 100vh;
}
.v-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.v-card-text {
  padding: 24px;
}
</style>
